import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { RouterProvider } from 'react-router'
import { queryClient, persistOptions } from '@/shared/lib/query-client'
import { router } from '@/shared/lib/router'
import ReloadPrompt from '@/shared/components/ReloadPrompt'
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { registerDeepLinkHandler } from '@/shared/lib/deep-links'

CapacitorUpdater.notifyAppReady()
void registerDeepLinkHandler()
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <RouterProvider router={router} />
      <ReloadPrompt />
    </PersistQueryClientProvider>
  </StrictMode>
)
